import React from "react";
import { observer } from "mobx-react-lite";
import { inspectionInfoStorage } from "../../services/ocr/InspectionInfoStorageModel";
import { Box, Card, CardMedia, Divider, Grid, Typography } from "@mui/material";
import { translationService } from "../../services/translation/TranslationService";

interface IDetectionListProps {
  inspectionInsightStorage: typeof inspectionInfoStorage;
}

const renderField = (label: string, value?: string | number) => {
  if (value === undefined || value === "") return <></>;
  return (
    <Grid container spacing = {1} alignItems= "flex-start">
      <Grid item>
        <Typography variant="body2" fontWeight="bold">
          {label}:
        </Typography>
      </Grid>
      <Grid item>
        <Typography variant="body2" >
          {value}
        </Typography>
      </Grid>
    </Grid>
  );
};

export const DetectionList = observer(({ inspectionInsightStorage }: IDetectionListProps) => {
  return (
    <Grid container spacing={2} sx={{ padding: 2 }} id = "pdf-content-list">
       <Grid item xs={12}>
        <Typography variant="h6" sx={{ textAlign: "left", display: "block" }}>
            {translationService.translate("ocrService.inspectionInfo.detectionList")}
        </Typography>
      </Grid>
        {inspectionInsightStorage.detections.map((detection, index) => (
          <Grid item xs={12} key={index}>
              <Card sx={{ display: "flex", mb: 2, flexDirection: "row", borderRadius: 2, border: "1px solid black", boxShadow: 8, overflow: "hidden" }} id="pdf-content-card">
                <Grid container>
                  <Grid item xs={12} sm={6}>
                    <Box sx={{ p: 2 }}>
                      {renderField(
                        translationService.translate("ocrService.inspectionInfo.time"),
                        new Date(detection.timestamp).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false })
                      )}
                      {renderField(translationService.translate("ocrService.inspectionInfo.distance"), detection.distance)}
                      {renderField("Main Code", detection.main_Code)}

                      <Divider sx={{ my: 1, borderBottom: "1px solid black", borderStyle: "dashed" }} />

                      {renderField("C1", detection.c1)}
                      {renderField("C2", detection.c2)}
                      {renderField("SA", detection.sa)}
                      {renderField("Q1", detection.q1)}
                      {renderField("Q2", detection.q2)}
                      {renderField(translationService.translate("ocrService.inspectionInfo.positionFrom"), detection.postionFrom)}
                      {renderField(translationService.translate("ocrService.inspectionInfo.positionTo"), detection.positionTo)}

                      <Divider sx={{ my: 1, borderBottom: "1px solid black", borderStyle: "dashed" }} />

                      {renderField(translationService.translate("ocrService.inspectionInfo.text"), detection.text)}
                   </Box>
                  </Grid>

                  <Grid item xs={12} sm={6} sx={{ display: "flex", alignItems: "center", justifyContent: "center", padding: 2 }}>
                    <CardMedia
                      component="img"
                      image={detection.frameUrl}
                      alt="frame"
                      sx={{ width: "100%", height: "auto", objectFit: "cover" }}
                    />
                  </Grid>
                </Grid>
              </Card>
          </Grid>
        ))}
    </Grid>
  );
});
